// 固定资产变更流程 | 前端模型（对应后端 EmArchFixedAssetChangeVo / QueryForm / SaveForm）
// Author Liang Gangqiang
// Date 2026-09-07
//
// 说明：
//  - gridFields() 是待办 / 列表页（em-table + em-filter，emWorkflowListMixin）的列定义，
//    字段名与 EmArchFixedAssetChangeVo 一一对应；
//  - filter 的键必须是「后端 QueryForm 字段名 + Filter」，
//    区间字段用后端已定义的 finishTimeRte / finishTimeLte（变更日期 = 流程结束时间）；
//  - 查询页走的是 QueryView（EmArchFixedAssetChange.jsc-import.json），不用本文件；
//  - 发起页 EmArchFixedAssetChangeEdit.vue 是自定义表单，也不用 entityFormConfigs，
//    这里保留最小一份，避免 em-table 在非 inlineActionsDisabled 模式下取到 undefined。

const CHANGE_TYPE_OPTIONS = [
    {value: 'ASSET_NAME', text: '资产名称'},
    {value: 'EQUIPMENT_CODE', text: '设备编码'},
    {value: 'COST_CENTER', text: '成本中心'}
];

const ASSET_STATUS_OPTIONS = [
    {value: 'NORMAL', text: '正常'},
    {value: 'DISPOSING', text: '处置中'},
    {value: 'WRITTEN_OFF', text: '已销账'}
];

class EmArchFixedAssetChange {
    constructor({
                    id = null,
                    workOrderCode = '',
                    status = '',
                    assetId = null,
                    changeType = '',
                    newAssetName = '',
                    newEquipmentCode = '',
                    newCostCenterId = null,
                    remark = ''
                } = {}) {
        this.id = id;
        this.workOrderCode = workOrderCode;
        this.status = status;
        this.assetId = assetId;
        this.changeType = changeType;
        this.newAssetName = newAssetName;
        this.newEquipmentCode = newEquipmentCode;
        this.newCostCenterId = newCostCenterId;
        this.remark = remark;
    }
}

function newEntity() {
    return new EmArchFixedAssetChange();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.asset.emArchFixedAssetChange.grid.id',
            sortable: true,
            isDetail: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'workOrderCode',
            label: 'label.em.asset.emArchFixedAssetChange.grid.workOrderCode',
            sortable: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'status',
            label: 'label.em.asset.emArchFixedAssetChange.grid.status',
            sortable: true,
            isDetail: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'statusName',
            label: 'label.em.asset.emArchFixedAssetChange.grid.statusName',
            sortable: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'assetNo',
            label: 'label.em.asset.emArchFixedAssetChange.grid.assetNo',
            sortable: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'subAssetNo',
            label: 'label.em.asset.emArchFixedAssetChange.grid.subAssetNo',
            sortable: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'assetName',
            label: 'label.em.asset.emArchFixedAssetChange.grid.assetName',
            sortable: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'equipmentCode',
            label: 'label.em.asset.emArchFixedAssetChange.grid.equipmentCode',
            sortable: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'costCenterName',
            label: 'label.em.asset.emArchFixedAssetChange.grid.costCenterName',
            sortable: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'deptName',
            label: 'label.em.asset.emArchFixedAssetChange.grid.deptName',
            sortable: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'assetStatus',
            label: 'label.em.asset.emArchFixedAssetChange.grid.assetStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string',
                options: ASSET_STATUS_OPTIONS
            }
        },
        {
            key: 'changeType',
            label: 'label.em.asset.emArchFixedAssetChange.grid.changeType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string',
                options: CHANGE_TYPE_OPTIONS
            }
        },
        {
            key: 'newAssetName',
            label: 'label.em.asset.emArchFixedAssetChange.grid.newAssetName',
            sortable: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'newEquipmentCode',
            label: 'label.em.asset.emArchFixedAssetChange.grid.newEquipmentCode',
            sortable: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'newCostCenterName',
            label: 'label.em.asset.emArchFixedAssetChange.grid.newCostCenterName',
            sortable: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'newDeptName',
            label: 'label.em.asset.emArchFixedAssetChange.grid.newDeptName',
            sortable: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'applicantName',
            label: 'label.em.asset.emArchFixedAssetChange.grid.applicantName',
            sortable: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'currentHandlers',
            label: 'label.em.asset.emArchFixedAssetChange.grid.currentHandlers',
            sortable: true,
            form: {type: 'input', modalMultiSelectedType: 'string'}
        },
        {
            key: 'createdTime',
            label: 'label.em.asset.emArchFixedAssetChange.grid.createdTime',
            sortable: true,
            form: {type: 'datetimepicker', modalMultiSelectedType: 'string'}
        },
        {
            key: 'finishTime',
            label: 'label.em.asset.emArchFixedAssetChange.grid.finishTime',
            sortable: true,
            form: {type: 'datetimepicker', modalMultiSelectedType: 'string'}
        },
        {
            key: 'remark',
            label: 'label.em.asset.emArchFixedAssetChange.grid.remark',
            sortable: true,
            form: {type: 'textarea', modalMultiSelectedType: 'string'}
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    workOrderCodeFilter: '',
    statusFilter: '',
    assetIdFilter: '',
    assetNoFilter: '',
    subAssetNoFilter: '',
    assetNameFilter: '',
    changeTypeFilter: '',
    applicantFilter: '',
    applicantNameFilter: '',
    currentHandlersFilter: '',
    assetStatusFilter: '',
    finishTimeRteFilter: '',
    finishTimeLteFilter: '',
    workflowQueryTypeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

// URS 需求_new R24–R28 / 验收 #9：变更日期区间、当前处理人、变更类型、资产状态、固资号
const filterConfigs = [
    {
        key: 'workOrderCodeFilter',
        label: 'label.em.asset.emArchFixedAssetChange.filter.workOrderCode',
        disabled: false,
        form: {type: 'input', modalMultiSelectedType: 'string'}
    },
    {
        key: 'statusFilter',
        label: 'label.em.asset.emArchFixedAssetChange.filter.status',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string',
            entity: 'emActProcessStatus',
            showLabelSelectOne: true,
            selectFilter: {processBusinessEntityFilter: 'EmArchFixedAssetChange', statusFilter: 1}
        }
    },
    {
        key: 'assetNoFilter',
        label: 'label.em.asset.emArchFixedAssetChange.filter.assetNo',
        disabled: false,
        form: {type: 'input', modalMultiSelectedType: 'string'}
    },
    {
        key: 'subAssetNoFilter',
        label: 'label.em.asset.emArchFixedAssetChange.filter.subAssetNo',
        disabled: false,
        form: {type: 'input', modalMultiSelectedType: 'string'}
    },
    {
        key: 'assetNameFilter',
        label: 'label.em.asset.emArchFixedAssetChange.filter.assetName',
        disabled: false,
        form: {type: 'input', modalMultiSelectedType: 'string'}
    },
    {
        key: 'changeTypeFilter',
        label: 'label.em.asset.emArchFixedAssetChange.filter.changeType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string',
            showLabelSelectOne: true,
            options: CHANGE_TYPE_OPTIONS
        }
    },
    {
        key: 'assetStatusFilter',
        label: 'label.em.asset.emArchFixedAssetChange.filter.assetStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string',
            showLabelSelectOne: true,
            options: ASSET_STATUS_OPTIONS
        }
    },
    {
        key: 'applicantNameFilter',
        label: 'label.em.asset.emArchFixedAssetChange.filter.applicantName',
        disabled: false,
        form: {type: 'input', modalMultiSelectedType: 'string'}
    },
    {
        key: 'currentHandlersFilter',
        label: 'label.em.asset.emArchFixedAssetChange.filter.currentHandlers',
        disabled: false,
        form: {type: 'input', modalMultiSelectedType: 'string'}
    },
    {
        key: 'finishTimeRteFilter',
        label: 'label.em.asset.emArchFixedAssetChange.filter.finishTimeRte',
        disabled: false,
        form: {type: 'datetimepicker', modalMultiSelectedType: 'string'}
    },
    {
        key: 'finishTimeLteFilter',
        label: 'label.em.asset.emArchFixedAssetChange.filter.finishTimeLte',
        disabled: false,
        form: {type: 'datetimepicker', modalMultiSelectedType: 'string'}
    }
];

// 发起 / 修改走自定义页面 EmArchFixedAssetChangeEdit.vue，这里只留备注
const entityFormConfigs = [
    {
        key: 'remark',
        label: 'label.em.asset.emArchFixedAssetChange.entity.remark',
        sortable: true,
        disabled: false,
        form: {type: 'textarea', modalMultiSelectedType: 'string'}
    }
];

export {
    EmArchFixedAssetChange,
    newEntity,
    gridFields,
    fields,
    filterFields,
    filter,
    filterConfigs,
    entityFormConfigs,
    CHANGE_TYPE_OPTIONS,
    ASSET_STATUS_OPTIONS
}
